export const posts = [
  {
    date: '2019-01',
    title: '一个简化版 Vue 助你理解 Vue 原理',
    category: '关于VueJs',
    url: 'https://github.com/YuFy1314/simpleVue',
  },
  {
    date: '2019-03',
    title: '前端常见的四种 JavaScript 排序算法',
    category: 'JS取经之路',
    url: 'http://yufy1314.github.io/',
  },
  {
    date: '2018-08',
    title: 'JavaScript 的事件执行机制 — 进阶必备',
    category: 'JS取经之路',
    url: 'http://yufy1314.github.io/',
  },
  {
    date: '2018-08',
    title: 'Vue 2.x + Webpack 4.x 的那些事 — 萌新必备',
    category: '关于VueJs',
    url: 'http://yufy1314.github.io/',
  },
  {
    date: '2018-08',
    title: 'Vue-cli + Element + Less 开发实践',
    category: '关于VueJs',
    url: 'http://yufy1314.github.io/',
  },
  {
    date: '2018-08',
    title: '搭建 Hexo & GitHub Pages 踩过的坑',
    category: '专业小tip',
    url: 'http://yufy1314.github.io/',
  },
  {
    date: '2018-08',
    title: '教你如何使用 nvm 管理 Node 版本',
    category: '在项目中掘金',
    url: 'http://yufy1314.github.io/',
  },
  {
    date: '2018-08',
    title: '深入浅出 ES6 — 系列导读',
    category: '深入浅出ES6',
    url: 'http://yufy1314.github.io/',
  },
];
